goog.provide('el8.uiwidget.ReactDialog');

goog.require('el8.model.base');
goog.require('el8.uiwidget.NewDialog');

/**
 * This is a subclass of NewDialog that represents a dialog whose content
 * will be purely handled by React
 */
el8.uiwidget.ReactDialog = function(spec) {

    spec = spec || {};

    el8.uiwidget.NewDialog.apply(this, arguments);

    this._reactDivId = spec.id || (Math.random().toString(36)+'00000000000000000').slice(2, 26);
    this._reactComponentFn = spec.reactComponentFn;
    this._reactProps = spec.reactProps || {};

	this._contentFn = function() {
        return "<div id=" + this._reactDivId + "></div>";
    };
};
el8.uiwidget.ReactDialog.inheritsFrom(el8.uiwidget.NewDialog);

el8.uiwidget.ReactDialog.prototype._init = function() {
    el8.uiwidget.NewDialog.prototype._init.apply(this, arguments);
};

el8.uiwidget.ReactDialog.prototype.setProps = function(props) {
    this._reactProps = props;
};

el8.uiwidget.ReactDialog.prototype.show = function() {
    el8.uiwidget.NewDialog.prototype.show.apply(this, arguments);
    if (this._reactComponentFn) {
        this._reactComponentFn(this._reactDivId, Object.assign(
          {},
          this._reactProps,
          { el8Close: this.hide.bind(this), el8Resize: this.adjustHeight.bind(this) }
        ));
    }
    this.adjustHeight(); // this will be super hacky
};

el8.uiwidget.ReactDialog.prototype.hide = function() {
    el8.uiwidget.NewDialog.prototype.hide.apply(this, arguments);
    el8React.unmountComponent(this._reactDivId);
};
